<mat-toolbar class="app-footer__toolbar">
  <mat-toolbar-row>
    <button
      mat-icon-button
      type="button"
      (click)="back()">
      <mat-icon svgIcon="arrow-left"></mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
